import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Youtube } from "lucide-react";

const FOOTER_LINKS = [
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
  { label: "Shipping", href: "/shipping" },
  { label: "Returns", href: "/returns" },
  { label: "FAQs", href: "/faqs" },
  { label: "Privacy Policy", href: "/privacy" },
];

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/augustautoagenciesltd/", Icon: Instagram },
  { label: "Facebook", href: "https://web.facebook.com/augustautoagenciesltd/", Icon: Facebook },
  { label: "X", href: "https://x.com", Icon: Twitter },
  { label: "YouTube", href: "https://youtube.com", Icon: Youtube },
];

export function Footer() {
  return (
    <footer className="border-t border-steel/10 bg-steel text-white">
      <div className="container-page grid gap-10 py-14 md:grid-cols-3">
        <div>
          <div className="mb-3 flex items-center gap-2">
            <img
              src="/logo.png"
              alt="August Auto Agencies"
              className="h-10 w-auto object-contain"
            />
            <span className="hidden font-display text-lg font-semibold uppercase tracking-wide text-steel sm:block">
              August Auto Agencies Ltd
            </span>
          </div>
          <p className="max-w-xs text-sm text-white/65">
            Premium hardware, electrical, and safety equipment trusted brands, fast delivery, built for the job.
          </p>
        </div>

        <nav aria-label="Footer">
          <h3 className="mb-4 font-display text-xs font-semibold uppercase tracking-wider text-red-400">Company</h3>
          <ul className="space-y-2.5">
            {FOOTER_LINKS.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="text-sm text-white/75 hover:text-red-300 transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="mb-4 font-display text-xs font-semibold uppercase tracking-wider text-red-400">Follow Us</h3>
          <div className="flex gap-3">
            {SOCIALS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="flex h-10 w-10 items-center justify-center rounded-sm border border-white/15 text-white/80 transition-colors hover:border-red-500 hover:text-red-400"
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-5">
        <p className="container-page text-center text-xs text-white/50">
          © {new Date().getFullYear()} August Auto Agencies Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}